import { Box, Button, Grid2, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { featureList } from "../constants/CreateProfileLists";
import fightIconBg from "../assets/images/flight-icon-with-bg.png";
import PlanSelectionModal from "./PlanSelectionModal";
import EditPaymentCard from "../pages/Profile/EditProfile/EditPaymentCard";
import CancelSubscription from "./CancelSubscriptionModal";
import Loader from "./Loader";
import usePlanCarousel from "../hooks/usePlanCarousel";
import CarouselArrowButtons from "./PlanCarousel/ArrowButtons";
import PlanCardHeader from "./PlanCarousel/PlanCardHeader";
import ApplySubscriptionDiscount from "./ApplySubscriptionDiscount";
import {
  cardWrapperSx,
  cardInnerSx,
  gradientHeaderSx,
  priceBadgeSx,
  activeBadgeSx,
  featureTextSx,
  actionButtonSx,
  featureListContainerSx,
} from "./PlanCarousel/styles";
import "../assets/styles/embla-carousel.css";

const ChangePlan = () => {
  const {
    emblaRef,
    emblaApi,
    activeIndex,
    handlePrev,
    handleNext,
    packInfo,
    loading,
    activePack,
    foundItem,
    handleCancelConfirm,
    showPayScreen,
    setShowPayScreen,
    handleClosePayScreen,
    selected,
    setSelected,
    selectedPlan,
    setSelectedPlan,
    openPlansModal,
    setOpenPlansModal,
  } = usePlanCarousel();

  const [showCancelPlanModal, setShowCancelModal] = useState(false);
  const role = localStorage.getItem("role");
  const queryParams = new URLSearchParams(window.location.search);
  const SHOW_EXCEL = queryParams.get("excel");

  const handleChange = (pack) => {
    if (activePack?.subscriptionPlanId === pack.id) {
      setShowCancelModal(true);
    } else {
      if (pack?.name !== "Free") {
        setOpenPlansModal(true);
      }
    }
    setSelected(pack);
  };

  useEffect(() => {
    if (!emblaApi || !packInfo?.length) return;
    if (SHOW_EXCEL) {
      const foundIndex = packInfo?.findIndex((item) =>
        item?.name?.toLowerCase().includes("excel"),
      );
      if (foundIndex >= 0) emblaApi.scrollTo(foundIndex);
    } else if (activePack) {
      const foundIndex = packInfo?.findIndex(
        (item) => item?.productId === activePack?.productId,
      );
      if (foundIndex >= 0) emblaApi.scrollTo(foundIndex);
    } else {
      const freeIndex = packInfo?.findIndex((item) =>
        item?.name?.toLowerCase().includes("free"),
      );
      if (freeIndex >= 0) emblaApi.scrollTo(freeIndex, true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emblaApi, packInfo?.length, activePack, SHOW_EXCEL]);

  const price = foundItem?.prices?.[1]?.unit_amount;

  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      {loading && <Loader />}
      {showPayScreen ? (
        <EditPaymentCard
          selectedPackage={packInfo[activeIndex]}
          selectedPlan={selectedPlan}
          handleClosePayScreen={handleClosePayScreen}
          setSelectedPlan={setSelectedPlan}
        />
      ) : (
        <Grid2 container sx={{ height: "100%" }}>
          <Grid2 item size={{ xs: 12 }} sx={{ height: "100%" }}>
            <Grid2 container sx={{ height: "100%" }}>
              <Box sx={{ width: "100%", height: "100%" }}>
                <Box
                  className="carousel-container carousel-container--edit carousel-container--padded"
                  sx={{ height: "100%" }}
                >
                  <CarouselArrowButtons
                    onPrev={handlePrev}
                    onNext={handleNext}
                  />

                  <div
                    className="embla embla--edit embla--fade embla--opaque-cards"
                    ref={emblaRef}
                  >
                    <div className="embla__container">
                      {packInfo &&
                        packInfo.map((pack, index) => {
                          const currentPackPrice =
                            pack?.prices?.[1]?.unit_amount;
                          return (
                            <div
                              className="embla__slide embla__slide--edit"
                              key={pack?.id}
                              onClick={() => emblaApi?.scrollTo(index)}
                            >
                              <div
                                className={`embla__slide__inner embla__slide__inner--edit${index === activeIndex ? " active" : ""}`}
                              >
                                <Box sx={cardWrapperSx}>
                                  <Box sx={cardInnerSx}>
                                    <Box
                                      sx={gradientHeaderSx(
                                        index === activeIndex,
                                      )}
                                    >
                                      <PlanCardHeader
                                        pack={pack}
                                        index={index}
                                        activeIndex={activeIndex}
                                      />

                                      {pack?.name !== "Free" && (
                                        <Box
                                          sx={{
                                            display: "flex",
                                            gap: "10px",
                                            backgroundColor: "transparent",
                                            paddingBottom: "8px",
                                          }}
                                        >
                                          <Typography
                                            variant="span"
                                            sx={priceBadgeSx(
                                              index === activeIndex,
                                            )}
                                          >
                                            {`${index === activeIndex ? "Monthly:" : ""}`}{" "}
                                            $
                                            {(
                                              pack?.prices[0]?.unit_amount / 100
                                            ).toFixed(2)}{" "}
                                            {`${index === activeIndex ? "" : "per month"}`}
                                          </Typography>
                                          <Typography
                                            variant="span"
                                            sx={priceBadgeSx(
                                              index === activeIndex,
                                            )}
                                          >
                                            {`${index === activeIndex ? "Yearly:" : ""}`}{" "}
                                            $
                                            {(
                                              pack?.prices[1]?.unit_amount / 100
                                            ).toFixed(2)}{" "}
                                            {`${index === activeIndex ? "" : "per year"}`}
                                          </Typography>
                                          {activePack?.subscriptionPlanId ===
                                            pack.id && (
                                            <Typography sx={activeBadgeSx}>
                                              Active
                                            </Typography>
                                          )}
                                        </Box>
                                      )}

                                      {pack?.name === "Free" && (
                                        <Box
                                          sx={{
                                            display: "flex",
                                            gap: "10px",
                                            paddingLeft: "16px",
                                            paddingBottom: "8px",
                                          }}
                                        >
                                          <Typography
                                            variant="span"
                                            sx={priceBadgeSx(
                                              index === activeIndex,
                                            )}
                                          >
                                            No Duration Limit
                                          </Typography>
                                          {!activePack && (
                                            <Typography
                                              variant="span"
                                              sx={priceBadgeSx(
                                                index === activeIndex,
                                              )}
                                            >
                                              Active
                                            </Typography>
                                          )}
                                        </Box>
                                      )}
                                    </Box>

                                    <Box sx={featureListContainerSx}>
                                      <Box
                                        sx={{
                                          padding: {
                                            xs: "15px",
                                            sm: "20px",
                                            xl: "20px 30px",
                                          },
                                          flex: 1,
                                          overflowY: "auto",
                                          marginBottom: "15px",
                                          width: "100%",
                                        }}
                                        className="card-inner-height"
                                      >
                                        {featureList[role][
                                          pack?.name?.toLowerCase().trim()
                                        ]?.map((item) => (
                                          <Box
                                            key={item[0]}
                                            sx={{
                                              textAlign: "left",
                                              marginBottom: "8px",
                                              display: "flex",
                                            }}
                                          >
                                            <img
                                              src={fightIconBg}
                                              alt=""
                                              style={{
                                                width: "21px",
                                                height: "21px",
                                                marginRight: "8px",
                                              }}
                                            />

                                            <Typography
                                              variant="h4"
                                              sx={featureTextSx(
                                                index === activeIndex,
                                              )}
                                            >
                                              {item.map((segment) => (
                                                <Typography
                                                  component="span"
                                                  key={segment.text}
                                                  sx={{
                                                    fontWeight: segment.bold
                                                      ? 600
                                                      : 400,
                                                  }}
                                                >
                                                  {segment.text}
                                                </Typography>
                                              ))}
                                            </Typography>
                                          </Box>
                                        ))}
                                      </Box>
                                      {index === activeIndex && (
                                        <>
                                          {/* Cancel Plan Button */}
                                          {activePack?.subscriptionPlanId ===
                                            pack.id &&
                                            activePack?.status !==
                                              "canceled" && (
                                              <Button
                                                onClick={() =>
                                                  handleChange(pack)
                                                }
                                                variant="outlined"
                                                sx={{
                                                  width: "60%",
                                                  backgroundColor: "",
                                                  borderRadius: "100px",
                                                  height: "50px",
                                                  borderColor: "#2A4876",
                                                  color: "red",
                                                  fontSize: "18px",
                                                  fontWeight: 400,
                                                  textTransform: "capitalize",
                                                  boxShadow: "none",
                                                  marginBottom: "15px",
                                                }}
                                              >
                                                Cancel Plan
                                              </Button>
                                            )}
                                          {activePack?.subscriptionPlanId ===
                                            pack.id && (
                                            <ApplySubscriptionDiscount
                                              activePack={activePack}
                                            />
                                          )}

                                          {/* Update Plan Button */}
                                          {activePack?.subscriptionPlanId !==
                                            pack.id &&
                                            pack?.name !== "Free" &&
                                            (!activePack ||
                                              price < currentPackPrice) && (
                                              <Button
                                                onClick={() =>
                                                  handleChange(pack)
                                                }
                                                variant="contained"
                                                sx={actionButtonSx}
                                              >
                                                Update Plan
                                              </Button>
                                            )}
                                        </>
                                      )}
                                    </Box>
                                  </Box>
                                </Box>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </Box>
              </Box>
            </Grid2>
          </Grid2>
        </Grid2>
      )}
      {openPlansModal && (
        <PlanSelectionModal
          openPlansModal={openPlansModal}
          handleCancel={() => setOpenPlansModal(false)}
          selectedPackage={selected}
          selectedPlan={selectedPlan}
          setSelectedPlan={setSelectedPlan}
          handleConfirm={() => {
            setShowPayScreen(true);
            setOpenPlansModal(false);
          }}
        />
      )}

      {showCancelPlanModal && (
        <CancelSubscription
          open={showCancelPlanModal}
          loading={loading}
          handleConfirm={() =>
            handleCancelConfirm(() => setShowCancelModal(false))
          }
          handleClose={() => setShowCancelModal(false)}
          userType={"individual"}
        />
      )}
    </Box>
  );
};

export default ChangePlan;
